import React from 'react';
import IconSvg, { IconSvgProps } from './IconSvg';

const KeyboardArrowDown = (props: IconSvgProps) => (
  <IconSvg {...props}>
    <path d="M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z" />
  </IconSvg>
);

export default KeyboardArrowDown;
